import { render, staticRenderFns } from "./GameContainer.vue?vue&type=template&id=02a1c12f&scoped=true"
import script from "./GameContainer.vue?vue&type=script&lang=js"
export * from "./GameContainer.vue?vue&type=script&lang=js"
import style0 from "./GameContainer.vue?vue&type=style&index=0&id=02a1c12f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a1c12f",
  null
  
)

export default component.exports